<template>
  <span
    :aria-hidden="decorative"
    :aria-label="title"
    class="cancel-pipe"
    role="img"
  >
    <svg
      :fill="fillColor"
      class="material-design-icon__svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        d="M2,5V13H4V11H10L12,9L10,7H4V5H2M20,5V7H12L14,9L12,11H20V13H22V5H20M12,13C12,13 10,15.17 10,16.5A2,2 0 0,0 12,18.5A2,2 0 0,0 14,16.5C14,15.17 12,13 12,13Z"
      />
      <path
        d="M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M12,4C7.58,4 4,7.58 4,12C4,13.85 4.63,15.55 5.68,16.91L16.91,5.68C15.55,4.63 13.85,4 12,4M12,20C16.42,20 20,16.42 20,12C20,10.15 19.37,8.45 18.32,7.09L7.09,18.32C8.45,19.37 10.15,20 12,20Z"
      />
      <title>{{ title }}</title>
    </svg>
  </span>
</template>

<script>
export default {
  name: "PipeCancelIcon",
  props: {
    title: {
      type: String,
      default: "Pipe cancel icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>
<style scoped>
.cancel-pipe {
  height: 24px;
}
</style>
